import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo, IHeaderButtonInfo, IRowButtonInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import ItemBusinessPartnerModel from '../../../models/ItemBusinessPartnerModel';
import DataService from "../../../services/data.service";
import { BusinessPartnerProps } from '../../../types/IdProps';
import AddItemPopup from '../Popups/BusinessPartner_popup_AddItem';

const BusinessPartner_tab_Items: React.FC<BusinessPartnerProps> = ({ businessPartnerId, businessPartnerTypeId }) => {
    const [data, setData] = useState<any[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, [businessPartnerId]);

    function getTableData() {
        DataService.get<any[]>('api/v1/ItemBusinessPartners/ByBusinessPartner/' + businessPartnerId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function getCellColor(itemBusinessPartner: ItemBusinessPartnerModel, colInfo: IColInfo) {
        if (itemBusinessPartner.itemRevision?.itemStatus)
            return itemBusinessPartner.itemRevision.itemStatus.color;

        return '';
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/ItemBusinessPartners/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'itemRevisionId', visible: false },
        { getCellBackgroundColor: getCellColor, sort: false },

        { title: 'Item Nr', dataProp: 'item', dataType: 'item' },
        { title: 'Name', dataProp: 'item.name', sort: 'asc' },
        { title: 'Version', dataProp: 'itemRevision.revisionNumber' },
        { title: 'Contactperson', dataProp: 'contactperson.name' },
        //{ title: 'Employee', dataProp: 'employee.user', dataType: 'user' },
        { title: 'Status', dataProp: 'itemRevision.itemStatus.name' },
        //{ title: 'Design phase', dataProp: 'itemRevision.designPhase' },
    ];

    if (isAuthorizedFor(ApplicationFunctions.UpdateBusinessPartner)) {
        let headerButtons: IHeaderButtonInfo[] = [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }];
        let rowButtons: IRowButtonInfo[] = [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }];
        colInfos.push({ headerButtons: headerButtons, rowButtons: rowButtons });
    }

    return (
        <>
            <DataTable
                name='dtBusinessPartnerItemRevisions'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Itemrevision'
                navigateUrl='/plm/Items/ItemRevision/'
            />
            <AddItemPopup businessPartnerId={businessPartnerId} businessPartnerTypeId={businessPartnerTypeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />
        </>
    );
}

export default BusinessPartner_tab_Items;